module.exports = __webpack_public_path__ + "fonts/VarelaRound-Regular.159cb67f.ttf";